import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseService } from "projects/assist/src/app/_shared/services/base.service";

import { HotToastService } from "@ngneat/hot-toast";
import { IdObject } from "projects/assist/src/app/_shared/models/basicDto";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OrganizationRelationService extends BaseService<IdObject<number>, IdObject<number>> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string,
    protected override toast: HotToastService
  ) {
    super(http, baseUrl, "OrganizationRelation", toast);
  }

  public isChild(parentId: number, relationTypeId?: number): Observable<boolean> {
    return this.get(`/isChild?parentId=${parentId}&relationTypeId=${relationTypeId}`);
  }
}
